var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[_vm._v("© NRW, Geobasis NRW, GeoBasis-DE/BKG "+_vm._s(new Date().getFullYear()))])}
var staticRenderFns = []

export { render, staticRenderFns }